<!--
//================================================================================
// ID:BC090
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:BC090
//
// <<Modification History>>
// Version	| Date		 | Updated By			   | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2023/03/28 | 富士通Japan株式会社		| 新規作成
// 01.01.00 | 2023/08/08 | 富士通Japan株式会社		| 令和5年度改修対応（3次リリース）
//================================================================================
-->
<template>
	<main class="contents__main">
		<error-message />
		<div>
			<table class="contents__table--stripe detail">
				<tbody>
					<tr class="contents__input--tr">
						<th class="contents__input--title">
							稼働日付<span class="contents__hissu">必須</span>
						</th>
						<td class="padding__top-zero">
							<date-input
								:modelValue="form.kadoDate"
								:name="'稼働日付'"
								:groupId="'kadoDateSet'"
								:requireFlg="true"
								:dateType="DATE_KIND.KADO_DATE"
								@update:modelValue="form.kadoDate = $event"
								ref="kadoDate"
								tabindex="1"
							/>
							<itemerror-message :groupId="'kadoDateSet'"/>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<br /><br />
		<div class="contents__div--center margin__bottom-page">
			<input
				type="button"
				value="設定する"
				class="contents__btn--confirm"
				tabindex="4"
				@click="kadoDateSettingBtn"
				/>
		</div>
	</main>
</template>

<script>
import ErrorMessage from '@/components/ErrorMessage.vue';
import ItemErrorMessage from '@/components/ItemErrorMessage.vue';
import DateInput from '@/components/DateInput.vue';

import { co_post, co_put } from "@/common/ajaxUtility.js";
import { co_completedDialog } from '@/common/dialogUtility.js';
import { co_getMessage } from '@/common/messageUtility.js';
import { co_toTrans } from '@/common/screenUtility.js';

import { DATE_KIND, DIALOG_BUTTON_LIST_KEY } from '@/const/const.js';
import { PATH_BC090_INIT, PATH_BC090_UPDATE } from "@/const/route.js";
import { STORE_ERROR_CLEAR, STORE_VIEW_PROGRESS, STORE_ERROR_IS_ERRFLG } from '@/const/store.js';

export default {
	name: "BC090",
	components: {
		'error-message': ErrorMessage,
		'itemerror-message': ItemErrorMessage,
		'date-input': DateInput,
	},
	data: function () {
		return {
			form: {
				unyoDate: '',	// 運用日付（DB項目）
				kadoDate: '',	// 稼働日付（画面項目）
			},
			DATE_KIND: DATE_KIND,
		}
	},
	created: async function () {

		// エラークリア
		this.$store.commit(STORE_ERROR_CLEAR);

		// ローディング表示開始
		this.$store.commit(STORE_VIEW_PROGRESS, true);

		// 稼働日付初期値情報取得
		let initKadoDate = await co_post(PATH_BC090_INIT);

		// 取得した稼働日付がnullまたは空の場合
		if (initKadoDate.kadoDate == null || initKadoDate.kadoDate == '') {
			let sysDate = new Date();
			let sysYear = String(sysDate.getFullYear());
			let sysMonth = ('0' + (sysDate.getMonth() + 1)).slice(-2);
			let sysDay = ('0' + sysDate.getDate()).slice(-2);
			// システム日付表示
			this.form.kadoDate = sysYear + sysMonth + sysDay;
		} else {
			// 取得した稼働日付がnullまたは空でない場合
			// 設定されている稼働日付表示
			this.form.kadoDate = initKadoDate.kadoDate;

			// unyoDateに取得した稼働日付を設定
			this.form.unyoDate = initKadoDate.kadoDate;
		}
		this.$refs.kadoDate.setValue(this.form.kadoDate);

		// ローディング表示終了
		this.$store.commit(STORE_VIEW_PROGRESS, false);
	},
	mounted: async function () {

		await this.$nextTick();

		// フォーカス制御
		this.$refs.kadoDate.focus();
	},
	methods: {
		// 設定するボタン押下字処理
		kadoDateSettingBtn: async function () {

			// エラーをクリア
			this.$store.commit(STORE_ERROR_CLEAR);

			// ローディング表示開始
			this.$store.commit(STORE_VIEW_PROGRESS, true);

			// 単項目チェック
			this.$refs.kadoDate.validate();

			// 入力チェックエラーが存在する場合
			if (this.$store.getters[STORE_ERROR_IS_ERRFLG]) {
				// ローディング表示終了
				this.$store.commit(STORE_VIEW_PROGRESS, false);
				
				return;
			} else {
				// 入力チェックエラーが存在しない場合
				// 運用マスタ登録処理
				await co_put(PATH_BC090_UPDATE, this.form);

				// ローディング表示終了
				this.$store.commit(STORE_VIEW_PROGRESS, false);

				// 完了ダイアログ表示
				co_completedDialog(co_getMessage("I0036"), this.doCompletedUpdate);
				return;
			}
		},
		doCompletedUpdate: function (flg) {

			// ダイアログ「はい」ボタン押下時処理
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {

				// メニュー画面へ遷移
				co_toTrans("BC002");
			}
		}
	}
}
</script>

<style scoped>

</style>
